/** # 根级别的 mutation */
import { RootState } from './interfaces'
const mutations = {
  increment(state: RootState, delta: number) {
    state.count = state.count + delta
  }
}

export default mutations
